import { useEffect, useState } from "react"
import { star_icons } from "./random_icons"
import GutterComponent from "./GutterComponent";

export default function Gutter({ side }: { side: 'left' | 'right' }) {
    const [star_urls, setStarUrls] = useState([]);
    const [startOptions, setStarOptions] = useState({})
    useEffect(() => {
        let temp = [];
        let options = {};
        for (let i = 0; i < 5; i++) {
            let url = star_icons[Math.floor(Math.random() * star_icons.length)]
            temp.push(url);
            options[url] = {
                left: `${Math.floor((Math.random() * 4) + 3)}vw`,
                top: `${Math.floor((Math.random() * 20) + 10)}vh`
            }
        }
        setStarUrls(temp);
        setStarOptions(options)
    }, [])
    return (
        <div style={{
            position: 'fixed',
            bottom: `calc(29vh)`,
            ...(side === 'right' ? { right: '15vw' } : {})
        }}>
            {star_urls.map((starUrl) => {
                return <GutterComponent
                    images={[starUrl]}
                    top={startOptions[starUrl].top}
                    left={startOptions[starUrl].left} />
            })}
        </div>
    )
}